var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
function IconInfoComponent(props, ref) {
    var _a = props.className, className = _a === void 0 ? '' : _a, _b = props.prefix, prefix = _b === void 0 ? 'arco' : _b, _c = props.width, width = _c === void 0 ? '1em' : _c, _d = props.height, height = _d === void 0 ? '1em' : _d, _e = props.useCurrentColor, useCurrentColor = _e === void 0 ? true : _e, rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
    return React.createElement("svg", __assign({ className: "".concat(prefix, "-icon ").concat(prefix, "-icon-info ").concat(className), width: width, height: height, viewBox: "0 0 17 17", fill: useCurrentColor ? 'currentColor' : '#000', xmlns: "http://www.w3.org/2000/svg" }, rest, { ref: ref }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.983 12.862V5.496h-1v7.366h1zM7.981 4.638h1.002V3.635H7.981v1.003z", fillOpacity: "1" }));
}
var IconInfo = React.forwardRef(IconInfoComponent);
export default IconInfo;
